import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Border & Colors spinner"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "spinner-border text-primary me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-secondary me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-success me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-danger me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-warning me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-info me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-light me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-border text-dark me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"spinner-border text-primary\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-secondary\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-success\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-danger\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-warning\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-info\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-light\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-border text-dark\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Growing spinner"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "spinner-grow text-primary me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-secondary me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-success me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-danger me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-warning me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-info me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-light me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ]),
              _createElementVNode("div", {
                class: "spinner-grow text-dark me-1",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"spinner-grow text-primary\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-secondary\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-success\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-danger\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-warning\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-info\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-light\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n<div class=\"spinner-grow text-dark\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Spinner Placement"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex justify-content-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"spinner-border\" role=\"status\">\n<span class=\"visually-hidden\">Loading...</span>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Spinner Placement"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("strong", { role: "status" }, "Loading..."),
                _createElementVNode("div", {
                  class: "spinner-border ms-auto",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"d-flex align-items-center\">\n<strong role=\"status\">Loading...</strong>\n<div class=\"spinner-border ms-auto\" aria-hidden=\"true\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Buttons Spinners"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-primary me-1",
                type: "button",
                disabled: ""
              }, [
                _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", {
                  class: "visually-hidden",
                  role: "status"
                }, "Loading...")
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary me-1",
                type: "button",
                disabled: ""
              }, [
                _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", { role: "status" }, "Loading...")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<button class=\"btn btn-primary\" type=\"button\" disabled>\n<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n<span class=\"visually-hidden\" role=\"status\">Loading...</span>\n</button>\n<button class=\"btn btn-primary\" type=\"button\" disabled>\n<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n<span role=\"status\">Loading...</span>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Backgrounds Label"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-primary me-1",
                type: "button",
                disabled: ""
              }, [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", {
                  class: "visually-hidden",
                  role: "status"
                }, "Loading...")
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary me-1",
                type: "button",
                disabled: ""
              }, [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", { role: "status" }, "Loading...")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<button class=\"btn btn-primary\" type=\"button\" disabled>\n<span class=\"spinner-grow spinner-grow-sm\" aria-hidden=\"true\"></span>\n<span class=\"visually-hidden\" role=\"status\">Loading...</span>\n</button>\n<button class=\"btn btn-primary\" type=\"button\" disabled>\n<span class=\"spinner-grow spinner-grow-sm\" aria-hidden=\"true\"></span>\n<span role=\"status\">Loading...</span>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}